import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import "./../css/momenu.css"
import "./../css/output.css"
import "./../js/scroll.js"

import commonJson from "./../json/common.json"
import displayJson from "./../json/display.json"
import eventJson from "./../json/event.json"
import goodsJson from "./../json/goods.json"
import memberJson from "./../json/member.json"
import orderJson from "./../json/order.json"

const jsonpath = require("jsonpath")
const commonjs = require("./../js/common.js")

export const CommomnData = () => {
	return commonJson
}
export const DisplayData = () => {
	return displayJson
}
export const EventData = () => {
	return eventJson
}
export const GoodsData = () => {
	return goodsJson
}
export const MemberData = () => {
	return memberJson
}
export const OrderData = () => {
	return orderJson
}

const Navi = (modulsName) => {
	const [data, setData] = useState(null) // 데이터 상태
	useEffect(() => {
		async function fetchData(modulsName) {
			let jsonData
			switch (modulsName) {
				case "common":
					jsonData = CommomnData()
					break
				case "display":
					jsonData = DisplayData()
					break
				case "event":
					jsonData = EventData()
					break
				case "goods":
					jsonData = GoodsData()
					break
				case "member":
					jsonData = MemberData()
					break
				case "order":
					jsonData = OrderData()
					break
				default:
					jsonData = ""
					break
			}
			setData(commonjs.getJsonPathMap(jsonData, jsonpath))
		}
		fetchData(modulsName) // 데이터를 가져오는 함수 호출
	}, []) // 빈 배열을 전달하여 컴포넌트가 마운트될 때 한 번만 실행
	return data
}

const MoSidebar = () => {
	const commonNavi = Navi("common")
	const displayNavi = Navi("display")
	const eventNavi = Navi("event")
	const goodsNavi = Navi("goods")
	const memberNavi = Navi("member")
	const orderNavi = Navi("order")
	const navigate = useNavigate()

	const handleLink = (param, depth) => {
		commonjs.HandlePage()
		navigate("/content?msa=" + param + "&depth=" + depth)
	}
	const handleOpen = (param, index, target) => {
		commonjs.HandleMoMenu(target)
	}
	const handleHome = () => {
		window.open("https://tech.x2bee.com/", "_blank")
	}

	return (
		<nav role="navigation">
			<div className="m_menu m_menu_toggle">
				{/* hamburger menu icon -start */}
				<input id="hamburger" type="checkbox" />
				<span></span>
				<span></span>
				<span></span>
				{/* hamburger menu icon -end */}

				{/* hamburger navigation -start */}
				<ul className="m_menu_navi">
					<div className="th_home">
						<a href="#" onClick={handleHome.bind(null)}>
							TECH HUB
						</a>
					</div>
					<div className="th_fo">
						<a href="https://apibo.x2bee.com/">BO API</a>
					</div>
					<div className="mb_menu">
						<div className="mo_theme">
							<svg className="h-6 w-6" viewBox="0 0 24 24" fill="none">
								<path d="M6 8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8ZM6 15a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1Z" className="fill-purple-400 group-hover:fill-purple-500 dark:group-hover:fill-purple-300 dark:fill-slate-600"></path>
								<path d="M13 8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V8Z" className="fill-purple-200 group-hover:fill-purple-300 dark:group-hover:fill-white dark:fill-slate-400"></path>
								<path d="M13 15a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1Z" className="fill-purple-400 group-hover:fill-purple-500 dark:group-hover:fill-purple-300 dark:fill-slate-600"></path>
							</svg>
							<span>FO API summary</span>
						</div>
						<div className="sm">
							<ul>
								<li className="main_category" data-onoff="off" onClick={handleOpen.bind(null, this, 1)}>
									<a href="#">Common</a>
								</li>
								{commonNavi != null &&
									commonNavi.map((item, index) => (
										<li key={item.name} onClick={handleLink.bind(null, "common", item.name)} className="off">
											<a href="#">{item.name}</a>
										</li>
									))}
							</ul>
						</div>
						<div className="sm">
							<ul>
								<li className="main_category" data-onoff="off" onClick={handleOpen.bind(null, this, 2)}>
									<a href="#">Display</a>
								</li>
								{displayNavi != null &&
									displayNavi.map((item, index) => (
										<li key={item.name} onClick={handleLink.bind(null, "display", item.name)} className="off">
											<a href="#">{item.name}</a>
										</li>
									))}
							</ul>
						</div>
						<div className="sm">
							<ul>
								<li className="main_category" data-onoff="off" onClick={handleOpen.bind(null, this, 3)}>
									<a href="#">Event</a>
								</li>
								{eventNavi != null &&
									eventNavi.map((item, index) => (
										<li key={item.name} onClick={handleLink.bind(null, "event", item.name)} className="off">
											<a href="#">{item.name}</a>
										</li>
									))}
							</ul>
						</div>
						<div className="sm">
							<ul>
								<li className="main_category" data-onoff="off" onClick={handleOpen.bind(null, this, 4)}>
									<a href="#">Goods</a>
								</li>
								{goodsNavi != null &&
									goodsNavi.map((item, index) => (
										<li key={item.name} onClick={handleLink.bind(null, "goods", item.name)} className="off">
											<a href="#">{item.name}</a>
										</li>
									))}
							</ul>
						</div>
						<div className="sm">
							<ul>
								<li className="main_category" data-onoff="off" onClick={handleOpen.bind(null, this, 5)}>
									<a href="#">Member</a>
								</li>
								{memberNavi != null &&
									memberNavi.map((item, index) => (
										<li key={item.name} onClick={handleLink.bind(null, "member", item.name)} className="off">
											<a href="#">{item.name}</a>
										</li>
									))}
							</ul>
						</div>
						<div className="sm">
							<ul>
								<li className="main_category" data-onoff="off" onClick={handleOpen.bind(null, this, 6)}>
									<a href="#">Order</a>
								</li>
								{orderNavi != null &&
									orderNavi.map((item, index) => (
										<li key={item.name} onClick={handleLink.bind(null, "order", item.name)} className="off">
											<a href="#">{item.name}</a>
										</li>
									))}
							</ul>
						</div>
					</div>
				</ul>
				{/* hamburger navigation -end */}
			</div>
		</nav>
	)
}

export default MoSidebar
